import {CardOo} from '../../components/CardOo/CardOo';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {ReservationPrices} from './ReservationPrices';
import {shouldRenderReservationCard} from './utils/shouldRenderReservationCard';

type ReservationCardType = {
  isExpired?: boolean;
};

export function ReservationCard(_props: ReservationCardType) {
  const offer = useGetOnlineOfferData();

  if (!shouldRenderReservationCard(offer)) {
    return null;
  }

  return (
    <CardOo backgroundColor="semantic.bg.subtle">
      <ReservationPrices />
    </CardOo>
  );
}
